import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pa-signup-otp',
  templateUrl: './signup-otp.component.html',
  styleUrls: ['./signup-otp.component.scss']
})
export class SignupOtpComponent implements OnInit {

  config = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '50px',
      height: '50px',
    }
  };

  deadline = Date.now() + 1000 * 60 * 60;

  constructor() { }

  ngOnInit(): void {
  }

  onOtpChange(event: string) {
    return true;
  }
}
